import { getCookie } from '../utils/utils';

// Avoid re-POSTing the same building repeatedly within a session. Capped so a
// long browsing session over hundreds of buildings can't grow this unbounded;
// oldest ids cycle out (insertion order) once the cap is hit.
const MAX_SENT_SIZE = 500;
const sent = new Set<string>();

// Record an id as sent, evicting the oldest entry when the cap is reached.
const markSent = (id: string): void => {
  if (sent.size >= MAX_SENT_SIZE) {
    const oldest = sent.values().next().value;
    if (oldest !== undefined) sent.delete(oldest);
  }
  sent.add(id);
};

/**
 * Fire-and-forget: remember {id, centroid} so a cold BARE link (no &lat&lng, no
 * listing) to a building seen on the map can still be located. Best-effort —
 * never blocks or throws.
 */
export function recordBuildingCentroid(
  id: string,
  lat: number,
  lng: number,
): void {
  if (!id || sent.has(id)) return;
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;
  markSent(id);
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 5000);
  fetch(`${process.env.REACT_APP_API_URL}/building-centroid`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-TOKEN': getCookie('csrf_access_token') || '',
    },
    body: JSON.stringify({ id, centroid: { lat, lng } }),
    signal: controller.signal,
  })
    .catch(() => {
      sent.delete(id); // allow a later retry if it failed (incl. timeout)
    })
    .finally(() => clearTimeout(timeout));
}
